import { NgModule } from '@angular/core'
import {
  cartBaseTranslationChunksConfig,
  cartBaseTranslations
} from '@spartacus/cart/base/assets'
import { CartBaseRootModule } from '@spartacus/cart/base/root'
import { provideConfig } from '@spartacus/core'

@NgModule({
  imports: [CartBaseRootModule],
  providers: [
    provideConfig({
      i18n: {
        resources: cartBaseTranslations,
        chunks: cartBaseTranslationChunksConfig,
        fallbackLang: 'en',
      },
    }),
  ],
})
export class CartBaseFeatureModule {
}
